import React from 'react';
import { connect } from 'redux-bundler-react';
import DatasetInfo from './dataset-info-modal';
import classnames from 'classnames';
import makeCancelable from '../../utils/makeCancelable';

/*

*/

let request = obj => {
  return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(obj.method || "GET", obj.url);
      if (obj.headers) {
          Object.keys(obj.headers).forEach(key => {
              xhr.setRequestHeader(key, obj.headers[key]);
          });
      }
      xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
              resolve(xhr.response);
          } else {
              reject(xhr.statusText);
          }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send(obj.body);
  });
};

class ProjectTreeLeaf extends React.Component {
  constructor(props){
    super(props);
    const source = props.item.mapLayer.getSource();
    const sourceName = props.item.type;
    let sourceType = 'tile';
    if(sourceName !== 'VectorSource') {
      switch(sourceName) {
        case 'TileWMS':
          sourceType = 'tile';
          break;
        case 'WMS':
          sourceType ='image';
          break;
        default:
          break;
      }
    }
    this.state ={
      source: source,
      isLoading: false,
      expanded: false,
      loadingCount: 0,
      loadedCount: 0,
      checkingExtent: false,
      percentage: 0,
      sourceName:sourceName,
      sourceType:sourceType,
      fetchingExtent:false,
    }
    this.toggleVisible = this.toggleVisible.bind(this);
    this.openMetadata = this.openMetadata.bind(this);
    // this.renderInfoButton = this.renderInfoButton.bind(this);
    this.renderMapSheetsButton = this.renderMapSheetsButton.bind(this);
    this.renderRasterReclassButton = this.renderRasterReclassButton.bind(this);
    this.openSecondaryPanel= this.openSecondaryPanel.bind(this);
    this.addLoading = this.addLoading.bind(this);
    this.addLoaded = this.addLoaded.bind(this);
    this.update = this.update.bind(this);
    this.removeListener = this.removeListener.bind(this);
    this.addListener = this.addListener.bind(this);
    this.zoomTo = this.zoomTo.bind(this);
    this.checkExtent = this.checkExtent.bind(this);
    this.renderExtentIcon = this.renderExtentIcon.bind(this); 
    // this.renderMapsOnDemandButton=this.renderMapsOnDemandButton.bind(this);
  }

  toggleVisible() {
    const { item, doLayerSetVisible } = this.props;
    if(!item.visible) {
      this.addListener();
    }else{
      this.removeListener();      
    }
    
    doLayerSetVisible(item.uid, !item.visible);
  }

  openMetadata(){
    const { doOpenModalWindow, item } = this.props;
    doOpenModalWindow({
      children: [DatasetInfo],
      options: {item: item},
      openedBy: 'ds-tree'
    })
  }
  
  componentDidMount () {
    this.addListener();    
  }
  addListener () {
    const { source, sourceName, sourceType } = this.state;
    if(sourceName !== 'VectorSource') {
      
      const layerStart = sourceType+'loadstart'; 
      const layerEnd = sourceType+'loadend';
      const layerError = sourceType+'loaderror';

      source.on(layerStart, this.addLoading);
      source.on(layerEnd, this.addLoaded);
      source.on(layerError, this.addLoaded);
    }
  }
  removeListener () {
    const { source, sourceName, sourceType } = this.state;
    if(sourceName !== 'VectorSource') {
      
      const layerStart = sourceType+'loadstart'; 
      const layerEnd = sourceType+'loadend';
      const layerError = sourceType+'loaderror';

      source.un(layerStart, this.addLoading);
      source.un(layerEnd, this.addLoaded);
      source.un(layerError, this.addLoaded);
    }
    this.setState({isLoading:false, loadingCount:0, loadedCount:0, percentage:0})
  }

  componentWillUnmount () {
    this.removeListener()
    if(this.cancelablePromise) {
      this.cancelablePromise.cancel();
    }
  }

  addLoading(){
    if(parseInt(this.state.loadingCount) === 0){
      this.setState({isLoading: true});
    }
    var count = parseInt(this.state.loadingCount) + 1;
    this.setState({loadingCount: count});
    this.update();
  }
  addLoaded(){ 
    if(this.state.isLoading === true){
      var count = parseInt(this.state.loadedCount) + 1;
      this.setState({loadedCount: count});
      this.update();     
    }
  }
  update() {
    const calculation = this.state.loadedCount/this.state.loadingCount;
    var percentage = (calculation*100).toFixed();
    this.setState({percentage: percentage});
    if(this.state.loadingCount === this.state.loadedCount){
      this.setState({
        loadingCount: 0,
        loadedCount: 0,
        isLoading: false,
        percentage: 0
      });
    }
  }
  openSecondaryPanel(evt){
    const type = evt.currentTarget.dataset.type;
    const { doDsOpenMSExplorer, doDsOpenLayerConfig, doDsOpenRasterReclass, doDsOpenMapsOnDemand, item } = this.props;
    switch(type) {
      case 'config':
        doDsOpenLayerConfig(item)
        break;
      case 'raster':
        doDsOpenRasterReclass(item)
        break;
      case 'mapGrid':
        doDsOpenMSExplorer(item)
        break;
      case 'mapsOnDemand':
        doDsOpenMapsOnDemand(item)
        break;
      default:
        break;
    }
  }
  // renderInfoButton(){    
  //   return (
  //     <span
  //         data-type='info'
  //         onClick={this.openMetadata}
  //         title="More Information"
  //         style={{paddingLeft: '4px', cursor: 'pointer'}}
  //       >
  //         <i className="mdi mdi-alert-circle-outline"></i>
  //     </span>
  //   )
  // }
  renderMapSheetsButton(){
    const { item } = this.props;
    if(item.displayName !== 'Map Sheets') return null;
    return (
      <span
          onClick={this.openSecondaryPanel}
          data-type='mapGrid'
          title="Map Sheets Explorer"
          style={{paddingLeft: '4px', cursor: 'pointer'}}
        >
          <i className="mdi mdi-border-all"></i>
      </span>
    )
  }
  // renderMapsOnDemandButton(){
  //   const { item,  threeD } = this.props;
  //   if(item.displayName === 'Map Sheets') return null;
  //   let content;
  //   if(item.visible && !threeD) {
  //     content =(
  //       <span
  //         onClick={this.openSecondaryPanel}
  //         data-type='mapsOnDemand'
  //         title="Maps On Demand"
  //         style={{paddingLeft: '4px', cursor: 'pointer'}}
  //       >
  //         <i className="mdi mdi-image"></i>
  //     </span>
  //     )
  //   }else{
  //     content =(
  //       <span
  //         data-type='mapsOnDemand'
  //         title="Maps On Demand Layer Must Be Visible"
  //         style={{paddingLeft: '4px'}}
  //       >
  //         <i className="mdi mdi-image" style={{opacity:'0.2'}}></i>
  //     </span>
  //     )
  //   }
  //   return content
  // }
  renderRasterReclassButton(){
    const { item } = this.props;
    if(item.layerList && item.layerList[0]!=='cog_layer' && item.layerList[0]!=='cog_xyz') return null;
    return (
      <span
          onClick={this.openSecondaryPanel}
          data-type='raster'
          title="Raster Reclass"
          style={{paddingLeft: '4px', cursor: 'pointer'}}
        >
          <i className="mdi mdi-brush"></i>
      </span>
    )
  }
  zoomTo(){
    const {item, doZoomToExtent} = this.props;
    doZoomToExtent(item.extent);
  };
  checkExtent() {
    const {item, doSetCursor} = this.props;
     if(item.extent) {
      this.zoomTo()
     }else{
      doSetCursor('wait')
      this.setState({fetchingExtent: true});
      const urlObj = new URL(item.info.url);
      let url = (item.info.url).replace(/\btype=layer\b/,'type=extent');
      if(item.table==='FLOOD_DEPTH' || item.table==='LEVEE_AREA_FLOOD_DEPTH'|| item.table==='FLOOD_EXTENT_RASTER') {
        url = `${urlObj.origin}${urlObj.pathname}?id=${item.info.s3Location}`;
      }
      this.cancelablePromise = makeCancelable(
        request({url:url})
      );
      this.cancelablePromise
        .then((results) => {
          doSetCursor('default');
          this.setState({fetchingExtent: false});
          const jsonData = JSON.parse(results);
          item.extent=jsonData.extent;
          this.zoomTo();
        })
        .catch((e) => {
          doSetCursor('default')
          this.setState({fetchingExtent: false});
          console.error('XHR error', e);
        });
     } 
    
  };
  renderExtentIcon() {
    // rotate-right
    const { item } = this.props;
    const {fetchingExtent}=this.state;
    const { type } = item;
    const zoomClass = classnames({
      mdi: true,
      "mdi-map-marker": type === "POINT",
      "mdi-vector-line": type === "LINE",
      "mdi-vector-polygon": type === "POLYGON",
      "mdi-grid": type === "RASTER",
      "mdi-arrow-expand-all": type === "SERVICE" || type === "WMS" || type === "TileWMS"
    }); 
    let content=(<span
      onClick={this.checkExtent}
      className=""
      title="Zoom to Layer Extent"
      style={{paddingLeft: '4px', cursor: 'pointer'}}
    >
      <i className={zoomClass} />
    </span>)
    if(fetchingExtent) {
      content = (
        <span
            className=""
            title="Retriving Extent"
            style={{paddingLeft: '4px', cursor: 'wait'}}
          >
          <i className="mdi mdi-spin mdi-rotate-right" />
        </span>
      )
    }
    return content
  };
  render(){
    const { item, theme} = this.props;
    const { isLoading, percentage, expanded, sourceType } = this.state;
    const { displayName } = item; 
    const percentageTxt = percentage + "%";
    const showPercentage = isLoading ? 'percentage-style' : 'hide-percentage';
    const showLoadingIcon = isLoading ? 'loadingIcon' : 'hide-loadingIcon';
    const expanderClass = classnames({
      [theme]: expanded,
      "layertree-layeritem-detailsicon": true,
      expanded: expanded
    });
    let loadingIcon;
    
    if(sourceType === 'tile') {
      loadingIcon =(<span className={showPercentage} style={{ marginRight: "10px" }}>{percentageTxt}</span>)
    }else if(sourceType === 'image') {
      loadingIcon =(<span className={showLoadingIcon} style={{ marginRight: "10px" }}><i title="Retrieving Layer" className="mdi mdi-spin mdi-rotate-right" /></span>)
    }
    return (
      <div className="layertree-layeritem">
        
        
        <div style={{flexGrow:'1', display:'flex'}}> 
          {loadingIcon}
          <label title={displayName} className="checkbox-inline" style={{overflowWrap: 'break-word',whiteSpace: 'pre-wrap'}}>
            <input
              type="checkbox"
              checked={ item.visible }
              value={ item.visible }
              onChange={ this.toggleVisible }
            />
            {displayName}
          </label>
          { this.renderExtentIcon() }
          {/* { this.renderInfoButton() } */}
          { this.renderMapSheetsButton() }
          { this.renderRasterReclassButton() }
          {/* { this.renderMapsOnDemandButton() } */}
        </div>
        
        <span onClick={this.openSecondaryPanel} data-type='config' className={expanderClass}>
          <i className="mdi mdi-dots-horizontal" title="Layer Tools" />
        </span>
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  'selectThreeD',
  'doLayerSetVisible',
  'doSetCursor',
  'doOpenModalWindow',
  'doZoomToExtent',
  'doDsOpenLayerConfig',
  'doDsOpenMSExplorer',
  'doDsOpenRasterReclass',
  'doDsOpenMapsOnDemand',
  ProjectTreeLeaf
);